import { render, staticRenderFns } from "./ModalVinculacaoTecnicoComponent.vue?vue&type=template&id=935f3b3c&lang=pug"
import script from "./ModalVinculacaoTecnicoComponent.vue?vue&type=script&lang=js"
export * from "./ModalVinculacaoTecnicoComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalVinculacaoTecnicoComponent.vue?vue&type=style&index=0&id=935f3b3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports